import { useParams } from 'react-router-dom';
import { FC, ReactNode, createContext, useContext } from 'react';

import { Encumbrance } from 'types';

import { EncumbrancesTableContextType } from '../types/EncumbrancesTableContextType';
import { encumbrancesTableInitValue } from '../constants/encumbrancesTableInitValue';

const EncumbrancesTableContext = createContext<EncumbrancesTableContextType>(
  encumbrancesTableInitValue
);

export const EncumbrancesTableProvider: FC<{
  children: ReactNode;
  encumbrances: Encumbrance[];
  expandedRows: Set<number>;
  isAdmin: boolean;
  isReadOnly: boolean;
  handleToggleRowExpansion?: (index: number) => void; // eslint-disable-line
  handleViewEncumbrance?: (index: number) => void; // eslint-disable-line
  handleEditEncumbrance?: (index: number) => void; // eslint-disable-line
  handleRemoveEncumbrance?: (index: number) => void; // eslint-disable-line
}> = ({
  children,
  encumbrances,
  expandedRows,
  isAdmin = false,
  isReadOnly = false,
  handleEditEncumbrance,
  handleRemoveEncumbrance,
  handleToggleRowExpansion,
  handleViewEncumbrance,
}) => {
  const { societyId } = useParams();

  return (
    <EncumbrancesTableContext.Provider
      value={{
        data: {
          encumbrances,
          expandedRows,
          isAdmin,
          isReadOnly,
          isLoading: false,
        },
        actions: {
          handleToggleRowExpansion,
          handleViewEncumbrance,
          handleEditEncumbrance,
          handleRemoveEncumbrance,
        },
      }}
    >
      {children}
    </EncumbrancesTableContext.Provider>
  );
};

export const useEncumbrancesTable = () => {
  const context = useContext(EncumbrancesTableContext);
  if (!context) {
    throw new Error(
      'useEncumbrancesTable must be used within a EncumbrancesTableProvider'
    );
  }
  return context;
};
